
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Avatar,
    Box, Button, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../../styles.module.css';
import UnitList from "../unit/UnitList";
import ItemList from "../item/ItemList";
import BankList from "../bank/BankList";
import PartiesList from "../parties/PartiesList";
import ConditionsAdd from "../terms&Conditions/ConditionsAdd";
import CategoryList from "../category/CategoryList";
import BinList from "../bin/BinList";
import { Link } from "react-router-dom";
import Breadcrumb from "../../reusableComponent/Breadcrumb";

const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    marginRight: '2px',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    padding: '4px 4px 4px 4px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function MastersHome() {
    const [selectedTab, setSelectedTab] = useState(0);
    const [previousTabs, setPreviousTabs] = useState([]);

    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]); // Store the previous active tab
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]); // Remove the last tab from the previousTabs array
        }
    };

    return (
        <>
           <Breadcrumb
                        routeSegments={[
                            { name: 'Masters', },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
                <Grid container style={{ height: '420px', }}>
                    <Grid item xs={3} >
                        <List sx={{ width: '100%', display: 'inline-block' }}>
                            <>
                                <Link to="/masters/category-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            {/* <Avatar> */}
                                                <Typography className={`${styles.menu_i}`}> CM </Typography>
                                            {/* </Avatar> */}
                                        </ListItemAvatar>
                                        <ListItemText primary="CATEGORY MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/unit-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            {/* <Avatar> */}
                                                <Typography className={`${styles.menu_i}`}> UM </Typography>
                                            {/* </Avatar> */}
                                        </ListItemAvatar>
                                        <ListItemText primary="UNIT MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/bank-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                                <Typography className={`${styles.menu_i}`}> BM </Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="BANK MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/bin-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                         
                                                <Typography className={`${styles.menu_i}`}>BM</Typography>
                                         
                                        </ListItemAvatar>
                                        <ListItemText primary="BIN MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/item-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            
                                                <Typography className={`${styles.menu_i}`}>IM</Typography>
                                          
                                        </ListItemAvatar>
                                        <ListItemText primary="ITEM MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/party-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                         
                                                <Typography className={`${styles.menu_i}`}>PM</Typography>
                                        
                                        </ListItemAvatar>
                                        <ListItemText primary="PARTY MASTER" />
                                    </ListItem>
                                </Link>
                                <Link to="/masters/terms-masters" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                                <Typography className={`${styles.menu_i}`}>TC</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="TERMS & CONDITIONS MASTER" />
                                    </ListItem>
                                </Link>
                            </>
                        </List>
                    </Grid>
                </Grid>
            </Paper>
            {/* <Paper className={`${styles.list_container}`}>
                <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '32px', paddingLeft: '12px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#000000"
                            TabIndicatorProps={{
                                sx: { backgroundColor: "#ff6600", marginBottom: '17px' }
                            }}
                            variant="scrollable">
                            <CustomTab label={<HomeIcon />} {...a11yProps(0)} />
                            <CustomTab label="Item Categories" {...a11yProps(1)} />
                            <CustomTab label="Units" {...a11yProps(2)} />
                            <CustomTab label="Banks" {...a11yProps(3)} />
                            <CustomTab label="Bin" {...a11yProps(4)} />
                            <CustomTab label="Items" {...a11yProps(5)} />
                            <CustomTab label="Parties" {...a11yProps(6)} />
                            <CustomTab label="Terms & Conditions" {...a11yProps(7)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                      
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <CategoryList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <UnitList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3} >
                        <BankList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>

                    <TabPanel value={selectedTab} index={4}>
                        <BinList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={5}>
                        <ItemList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={6}>
                        <PartiesList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={7}>
                        <ConditionsAdd handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                </Box>
            </Paper> */}
        </>
    )
}

export default MastersHome;